angular.module( 'acme.view.application.partners.detail.membership', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.partners.detail.membership.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersDetailMembership = {
        name: 'application.partners.detail.membership',
        url: '/:membershipId/membership',
        views: {
          "subview-main@application": {
            controller: 'PartnersDetailMembershipController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/detail/membership/membership.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Membership'
        }
      };

    $stateProvider
      .state(partnersDetailMembership);
});
